import 'reflect-metadata';
import {
  Expose,
  Type,
  plainToInstance,
  instanceToPlain,
} from 'class-transformer';
import { UserStatus } from './enums/UserStatus';

export class GenealogyTreeview {
  @Expose({ name: 'genealogy' })
  @Type(() => GenealogyUser)
  users: GenealogyUser;

  @Expose({ name: 'search_valid' })
  searchValid: boolean;

  @Expose({ name: 'max_levels' })
  maxLevels: number;

  constructor(users: GenealogyUser, searchValid: boolean, maxLevels: number) {
    this.users = users;
    this.searchValid = searchValid;
    this.maxLevels = maxLevels;
  }

  static fromJson(json: Record<string, any>): GenealogyTreeview {
    return plainToInstance(GenealogyTreeview, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}

export class GenealogyUser {
  id: number;

  @Expose({ name: 'parent_id' })
  parentId: number;

  status: UserStatus;

  username: string;

  avatar?: string;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  dateCreated: Date;

  @Expose({ name: 'first_name' })
  firstname: string;

  @Expose({ name: 'last_name' })
  lastname?: string;

  level: number;

  @Expose({ name: 'total_earnings' })
  totalEarnings: string;

  @Expose({ name: 'downlines_count' })
  downlinesCount: number;

  @Type(() => GenealogyUser)
  children: GenealogyUser[];

  constructor(
    id: number,
    parentId: number,
    status: UserStatus,
    username: string,
    avatar: string | undefined,
    dateCreated: Date,
    firstname: string,
    lastname: string | undefined,
    level: number,
    totalEarnings: string,
    downlinesCount: number,
    children: GenealogyUser[]
  ) {
    this.id = id;
    this.parentId = parentId;
    this.status = status;
    this.username = username;
    this.avatar = avatar;
    this.dateCreated = dateCreated;
    this.firstname = firstname;
    this.lastname = lastname;
    this.level = level;
    this.totalEarnings = totalEarnings;
    this.downlinesCount = downlinesCount;
    this.children = children;
  }

  copyWithoutChildren(): GenealogyUser {
    return new GenealogyUser(
      this.id,
      this.parentId,
      this.status,
      this.username,
      this.avatar,
      this.dateCreated,
      this.firstname,
      this.lastname,
      this.level,
      this.totalEarnings,
      this.downlinesCount,
      []
    );
  }

  static fromJson(json: Record<string, any>): GenealogyUser {
    return plainToInstance(GenealogyUser, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
